import React from "react";

type MobilePhoneAppCheckProps = {
  color?: string;
  size?: string;
};

const MobilePhoneAppCheck = (props: MobilePhoneAppCheckProps) => {
  const { color, size } = props;
  
  const primaryColor = color || "#195FE9";
  
  if (size === "small") {
    return (
      <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#E5EEFF"/>
        <path d="M29.5 26.5V17C29.5 15.3431 28.1569 14 26.5 14H20.5C18.8431 14 17.5 15.3431 17.5 17V30M23.5 34H20.5C18.8431 34 17.5 32.6569 17.5 31V30M17.5 30H23.5M27.5 31.9631L29.817 34L34.5 29" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  if (size === "large") {
    return (
      <svg width="72" height="72" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#E5EEFF"/>
        <path d="M29.5 26.5V17C29.5 15.3431 28.1569 14 26.5 14H20.5C18.8431 14 17.5 15.3431 17.5 17V30M23.5 34H20.5C18.8431 34 17.5 32.6569 17.5 31V30M17.5 30H23.5M27.5 31.9631L29.817 34L34.5 29" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#E5EEFF"/>
      <path d="M29.5 26.5V17C29.5 15.3431 28.1569 14 26.5 14H20.5C18.8431 14 17.5 15.3431 17.5 17V30M23.5 34H20.5C18.8431 34 17.5 32.6569 17.5 31V30M17.5 30H23.5M27.5 31.9631L29.817 34L34.5 29" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default MobilePhoneAppCheck; 